module.exports = __webpack_public_path__ + "img/sand-decal-04.2b2e6749.png";